"use strict";

exports.__esModule = true;
var _HelpButton = require("./HelpButton");
Object.keys(_HelpButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HelpButton[key]) return;
  exports[key] = _HelpButton[key];
});
var _HelpContext = require("./HelpContext");
Object.keys(_HelpContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HelpContext[key]) return;
  exports[key] = _HelpContext[key];
});
var _HelpController = require("./HelpController");
Object.keys(_HelpController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HelpController[key]) return;
  exports[key] = _HelpController[key];
});
var _HelpPanel = require("./HelpPanel");
Object.keys(_HelpPanel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _HelpPanel[key]) return;
  exports[key] = _HelpPanel[key];
});